import { event } from 'model/notification';
import sleep from 'model/actions/city/sleep';
const action = 'TAKE_BOWL';
// Says what the bowl is and nothing about what it is for. Begging is discovered, not announced.
const notificationText = () => event(`a bowl`, `scuffed tin, dented at the rim. a dog drank from it. it holds water and that is enough.`);

const attempt = () => {
  const result = {
    success: true,
    gain: {
      bowl: true
    },
    cost: {}
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const {
    party: { history }
  } = context;

  history.add({ action, result }, context);

  result = sleep.execute(context);

  return { notification: notificationText(), ...result };
};

const takeBowl = notifyDone => ({
  title: sleep.title,
  hotkey: sleep.hotkey,
  type: action,
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    const sideEffects = executeSideEffects(context, result);
    notifyDone();
    return { result, ...sideEffects };
  }
});

export default takeBowl;
